import React from "react";

export default props => {
  let { type, className = "", ...other } = props;
  className += ` anticon anticon-${type}`;
  return (
    <i
      className={className.trim()}
      {...other}
      ecId={`${other.ecId}_i@0hqgzv`}
    />
  );
};



// WEBPACK FOOTER //
// ./_antd1.11.2/icon/index.jsx